// ✅ US Market Domains - Thin Wrapper (DRY principle)
import DomainsPage from '../../sub/domains';
import SEOHead from '../../../components/SEOHead';

export default function USDomains() {
  return (
    <>
      <SEOHead
        title='Domain Registration | LBVisible'
        description='Domain registration and management services for your website.'
        keywords='domain registration USA, domain names, web hosting'
        canonicalUrl='/us/sub/domains'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/sub/domains' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/sub/domains' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/sub/domenai' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/sub/domains' },
        ]}
      />

      <DomainsPage />
    </>
  );
}
